import React from 'react';
import { Typography } from '@mui/material';

import { type EditorHtmlFieldProps } from 'app/main/components/fields/EditorHtmlField';
import useSettings from 'app/main/components/hooks/useSettings';
import Icon from 'app/main/components/Icon';
import EditorHtmlField from 'app/main/components/fields/EditorHtmlField';
import HTMLRenderer from 'app/main/components/HTMLRenderer';
import DetailsSectionWrapper, { type DetailsSectionWrapperProps } from '../components/DetailsSectionWrapper';

type DetailsSectionDescriptionProps = Pick<
	EditorHtmlFieldProps,
	'name' | 'value' | 'isEdit' | 'sendChange' | 'logProps'
> &
	Pick<DetailsSectionWrapperProps, 'title' | 'subheader'>;

export default function DetailsSectionDescription(props: DetailsSectionDescriptionProps) {
	const { t } = useSettings();

	const hasLogs = props.logProps?.hasLogs(props.name);

	return (
		<DetailsSectionWrapper
			avatar={<Icon icon="card-text-outline" />}
			title={props.title || t('DETAILS_DESCRIPTION_SECTION')}
			subheader={props.subheader || t('DETAILS_DESCRIPTION_SUBHEADER')}
		>
			{props.isEdit || hasLogs ? (
				<EditorHtmlField
					name={props.name}
					value={props.value}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			) : props.value ? (
				<HTMLRenderer value={props.value} />
			) : (
				<Typography className="italic" color="textSecondary">
					{t('VIEW_ITEM_NO_DESCRIPTION')}
				</Typography>
			)}
		</DetailsSectionWrapper>
	);
}
